import React, {useState} from 'react';
import {Button, Chip, CircularProgress, Modal, Radio} from '@mui/material';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {
    ActionsContainer,
    MethodInfo,
    MethodOption,
    MethodSubtitle,
    MethodTitle,
    ModalContent,
    ModalSubtitle,
    ModalTitle,
} from './styles';
import {useDashboardContext} from "../../../Dashboard";
import {LifepayButton} from "../../../../LifepayButton";

export default function PaymentModal({price, open, onClose}) {
    const {PAYMENT_DATA, onSendInvoice, user_id, email} = useDashboardContext();
    const [selectedMethod, setSelectedMethod] = useState('card');
    const [successStep, setSuccessStep] = useState(false);
    const [loading, setLoading] = useState(false);

    const handlePay = async () => {
        setLoading(true);
        PAYMENT_DATA.number = selectedMethod === "transfer" && await onSendInvoice(price);
        setLoading(false);
        setSuccessStep(true);
    };

    const handleFinish = async () => {
        setSuccessStep(false);
        onClose();
    };

    const Methods = () => {
        return (
            <>
                <ModalTitle>{PAYMENT_DATA.title}</ModalTitle>
                <ModalSubtitle>{PAYMENT_DATA.subtitle}</ModalSubtitle>

                {PAYMENT_DATA.methods?.map((method) => {
                    const isSelected = selectedMethod === method.id;
                    return (
                        <MethodOption key={method.id} selected={isSelected} onClick={() => setSelectedMethod(method.id)}>
                            <div style={{display: 'flex', alignItems: 'center', gap: 10}}>
                                {method.id === 'card' ? <CreditCardIcon color="primary"/> :
                                    <AccountBalanceIcon color="primary"/>}
                                <MethodInfo>
                                    <MethodTitle>{method.title}</MethodTitle>
                                    <MethodSubtitle>{method.subtitle}</MethodSubtitle>
                                </MethodInfo>
                            </div>
                            <div style={{display: 'flex', alignItems: 'center', gap: 6}}>
                                <Chip label={method.badge} size="small" variant={isSelected ? 'filled' : 'outlined'} color={isSelected ? 'secondary' : 'default'} style={{fontSize: 10}}/>
                                <Radio checked={isSelected} size="small" color="secondary"/>
                            </div>
                        </MethodOption>
                    );
                })}

                <ActionsContainer>
                    {selectedMethod === "card" ? (
                        <LifepayButton
                            email={email}
                            isTest={false}
                            serviceId={"ipresent.ru"}
                            recordId={user_id}
                            cost={price}
                            on_success={() => console.log(`on_success`) || handlePay()}
                            on_open={() => console.log("on_open")}
                            on_fail={() => console.log("on_fail")}
                            on_close={() => console.log("on_close")}
                        />
                    ) : (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handlePay}
                            style={{
                                textTransform: 'none',
                                borderRadius: 8,
                                backgroundColor: '#d81b60',
                                height: 42,
                                fontWeight: 600
                            }}
                        >
                            {PAYMENT_DATA.transferButtonText}
                        </Button>
                    )}


                    <Button variant="text" color="inherit" fullWidth onClick={onClose} style={{textTransform: 'none', fontSize: 13, color: '#666'}}>
                        {PAYMENT_DATA.cancelText}
                    </Button>
                </ActionsContainer>
            </>
        )
    }
    const Success = () => {
        return (
            <div style={{textAlign: 'center', padding: '10px 0'}}>
                <CheckCircleIcon color="success" style={{fontSize: 48, marginBottom: 8}}/>

                <ModalTitle>{selectedMethod === "card" ? PAYMENT_DATA.successModalTitle : PAYMENT_DATA.transferModalTitle}</ModalTitle>

                <ModalSubtitle>
                    {selectedMethod === "card" ? (
                        PAYMENT_DATA.successModalText
                    ) : (
                        <div>
                            <div>{PAYMENT_DATA.transferModalText1}</div>
                            <div>{PAYMENT_DATA.number}</div>
                        </div>
                    )}
                </ModalSubtitle>

                <Button variant="contained" color="primary" fullWidth onClick={handleFinish} style={{
                    textTransform: 'none',
                    borderRadius: 8,
                    backgroundColor: '#d81b60',
                    marginTop: 12
                }}>
                    {PAYMENT_DATA.closeButtonText}
                </Button>

            </div>
        )
    }
    const Loading = () => {
        return (
            <div style={{
                flexDirection: "column",
                display: "flex",
                justifyContent: "center",
                height: 100,
                alignItems: "center"
            }}>
                <CircularProgress/>
                {PAYMENT_DATA.loading}
            </div>
        )
    }

    return (
        <Modal open={open} onClose={onClose} style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <ModalContent>
                {loading ? <Loading/> : (
                    successStep ? <Success/> : <Methods/>
                )}
            </ModalContent>
        </Modal>
    );
}
